// atoms.ts
import { atom } from 'jotai';

export const feedbackCountAtom = atom(0);
export const serviceCommentsCountAtom = atom(0);
export const shipmentsCountAtom = atom(0);
export const completedShipmentsCountAtom = atom(0);